import React from 'react';
import {Dimensions, StyleSheet, View, Text, Pressable} from 'react-native';
import RoundedAppButton, {
  RoundedAppButtonType,
} from 'src/components/elements/RoundedAppButton';
import {Portal, Modal} from 'react-native-paper';
import WarningIcon from 'src/components/img/svg/WarningIcon';
import Localized from 'src/constants/AppStrings';
import Styles from '../Styles';
import Close from 'src/components/img/svg/Close';
import {getDescriber} from 'src/components/elements/descriptor/DescriptorType';

export type WarningDialogProps = {
  isVisible: boolean;
  title?: string;
  description?: string;
  buttonTitle?: string;
  closeAction?: () => void;
  buttonAction?: () => void;
};

const width = Dimensions.get('window').width;

const WarningDialog = (props: WarningDialogProps) => {
  return (
    <Portal>
      <Modal
        visible={props.isVisible}
        onDismiss={props.closeAction}
        style={styles.container}
      >
        <View style={styles.content} nativeID={'Warning_Dialog'}>
          <Pressable
            style={styles.topButtonView}
            onPress={props.closeAction}
            nativeID={'Warning_Dialog_Close'}
          >
            <Close />
          </Pressable>
          <View style={styles.iconView}>
            <WarningIcon />
          </View>
          <View style={styles.textView}>
            <Text
              nativeID={props.title ?? Localized.Labels.account_balance_message}
              maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
              style={[styles.titleText, getDescriber().fontStyleSuccessModal()]}
            >
              {props.title ?? Localized.Labels.account_balance_message}
            </Text>
            <Text
              nativeID={
                props.description ??
                Localized.Labels
                  .your_account_balance_is_not_supported_at_some_locations
              }
              maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
              style={[
                styles.descriptionText,
                getDescriber().fontStyleSuccessModal(),
              ]}
            >
              {props.description ??
                Localized.Labels
                  .your_account_balance_is_not_supported_at_some_locations}
            </Text>
          </View>
          <View style={styles.buttonView}>
            <RoundedAppButton
              buttonType={RoundedAppButtonType.Solid}
              titleText={props.buttonTitle ?? Localized.Buttons.okay}
              buttonContainerStyle={styles.buttonContainer}
              buttonViewStyle={styles.button}
              onPress={props.closeAction}
            />
          </View>
        </View>
      </Modal>
    </Portal>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    marginHorizontal: Styles.Spacing.m3 + Styles.Spacing.m2,
  },
  content: {
    width: width - Styles.Spacing.m3 * 2,
    borderRadius: Styles.Spacing.m3,
    overflow: 'hidden',
    backgroundColor: Styles.white,
    paddingHorizontal: Styles.Spacing.m2,
  },
  topButtonView: {
    alignItems: 'flex-end',
    justifyContent: 'center',
    height: Styles.Heights.touchTargetHeight2,
  },
  iconView: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  textView: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  titleText: {
    fontSize: Styles.Fonts.sectionHeader,
    fontWeight: '700',
    marginVertical: 12,
    marginHorizontal: Styles.Spacing.m2,
  },
  descriptionText: {
    fontSize: Styles.Fonts.f1,
    fontWeight: '400',
    marginHorizontal: Styles.Spacing.m2,
    marginVertical: 12,
    textAlign: 'center',
  },
  buttonView: {
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: Styles.Spacing.m4,
    marginTop: Styles.Spacing.m2,
  },
  buttonContainer: {
    alignSelf: 'center',
  },
  button: {
    paddingHorizontal: 24,
  },
});

export default WarningDialog;
